import apis from '@/api';
import { defineStore } from 'pinia';

const useCommonStore = defineStore('common', {
  state() {
    return {
      identityArr: [],
      channelArr: [
        { id: 1, name: '微信小程序' },
        { id: 2, name: 'PC' },
      ],
      sessionStatusArr: [
        { label: '未上架', value: '0' },
        { label: '在售中', value: '1' },
        { label: '已售罄', value: '2' },
        { label: '已下架', value: '3' },
      ],
      payStatusArr: [
        { label: '全部', value: '' },
        { label: '订单生成', value: '0' },
        { label: '支付中', value: '1' },
        { label: '支付成功', value: '2' },
        { label: '支付失败', value: '3' },
        { label: '已撤销', value: '4' },
        { label: '已退款', value: '5' },
        { label: '订单关闭', value: '6' },
      ],
      enrollStateArr: [
        { label: '报名成功', value: 1 },
        { label: '候补中', value: 2 },
        { label: '待支付', value: 5 },
      ],
    };
  },

  getters: {
    enrollStateMap(state) {
      let map = {};
      state.enrollStateArr.forEach((item) => {
        map[Number(item.value)] = item.label;
      });
      return map;
    },
    payStatusMap(state) {
      let map = {};
      state.payStatusArr.forEach((item) => {
        map[Number(item.value)] = item.label;
      });
      return map;
    },
    identityMap(state) {
      let map = {};
      state.identityArr.forEach((item) => {
        map[Number(item.id)] = item.name;
      });
      return map;
    },
  },
  actions: {
    async getDict(dictName, field) {
      const res = await apis.getDict(dictName);
      if (res.code == 200) {
        let temp = res.data.map((i) => {
          return {
            id: i.dictValue,
            name: i.dictLabel,
          };
        });
        this[field] = temp;
      }
    },
  },
});

export default useCommonStore;
